import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';
import WhatsAppButton from './components/WhatsAppButton';
import WhatsAppInfo from './components/WhatsAppInfo';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Contact from './pages/Contact';
import RSE from './pages/RSE';
import MentionsLegales from './pages/MentionsLegales';
import Batiment from './pages/Batiment';
import Habilitation from './pages/Habilitation';
import ElectriciteGenerale from './pages/ElectriciteGenerale';
import IRVE from './pages/IRVE';
import MaintenanceIndustrielle from './pages/MaintenanceIndustrielle';
import CGV from './pages/CGV';
import EnseignesLumineuses from './pages/EnseignesLumineuses';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App t-body" style={{margin: 0}}>
        <Header />
        <Breadcrumb />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/rse" element={<RSE />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/batiment" element={<Batiment />} />
            <Route path="/habielec" element={<Habilitation />} />
            <Route path="/elecgnrle" element={<ElectriciteGenerale />} />
            <Route path="/maintenindus" element={<MaintenanceIndustrielle />} />
            <Route path="/irve" element={<IRVE />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/enseignes" element={<EnseignesLumineuses />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <WhatsAppInfo />
        <BackToTop />
      </div>
    </Router>
  );
};

export default App;
